import React from 'react'

import LoadingSpinner from '@components/LoadingSpinner'
import useMain from '@hooks/useMain'
import { __ONE_SECOND__ } from '@types'

import { CustomProgressBar, LoadingContainer } from './styles'

interface ILoadingProperties {
    isLoading: boolean
    message: string
    currentWallet: string
    transactionHash: string
}

const __ONE_THIRD__ = 33
const __TWO_THIRD__ = 66
const __FULL__ = 100

const PaymentConfirm: React.FC<ILoadingProperties> = ({ isLoading, message, currentWallet, transactionHash }) => {
    const {
        state: {
            config,
            mainInit: { network, blockchain },
        },
        operations: { setCurrentStep },
    } = useMain()

    const [step, setStep] = React.useState(0)

    React.useEffect(() => {
        if (message === 'Confirming payment...') {
            setStep(__ONE_THIRD__)
        }
        if (message === 'Transaction sent') {
            setStep(__TWO_THIRD__)
        }
        if (message === 'Transfering your NFTs...') {
            setStep(__FULL__)
        }
    }, [message])

    React.useEffect(() => {
        if (message === 'Transaction rejected') {
            setCurrentStep(`payments-wallet`)
        }
    }, [currentWallet, message])

    React.useEffect(() => {
        if (step === __FULL__) {
            setTimeout(() => {
                setCurrentStep(`success`)
            }, __ONE_SECOND__)
        }
    }, [step])

    return (
        <>
            <LoadingContainer isLoading={isLoading}>
                <LoadingSpinner />
                <h2>{message}</h2>
                <CustomProgressBar animated now={step} />
                {transactionHash !== '' ? (
                    <h3 id="longer-ten-minutes">This could take up to 10 minutes or longer</h3>
                ) : (
                    <h3 id="please-confirm">Please, confirm the payment in your wallet.</h3>
                )}
                {transactionHash !== '' && (
                    <>
                        <h4 id="can-close-this-tab">You can close this tab and follow your transaction at </h4>
                        <a
                            id="link-to-transaction"
                            href={config.networks[network][blockchain].explorer_transaction + transactionHash}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {config.networks[network][blockchain].explorer_transaction}
                        </a>
                    </>
                )}
            </LoadingContainer>
        </>
    )
}

export default PaymentConfirm
